// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TruckImageUpload_wrapper__1sQ3g","upload":"TruckImageUpload_upload__nJqxb","files":"TruckImageUpload_files__K3syE"};